import { create } from "zustand";

interface Notification {
  id: string;
  text: string;
  timestamp: string;
  read: boolean;
  system?: boolean;
  user?: {
    avatar?: string;
  };
}

interface NotificationStore {
  notifications: Notification[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  markAllAsRead: () => void;
  markAsRead: (id: string) => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [
    {
      id: "1",
      text: "Notification text",
      timestamp: "5s ago",
      read: false,
    },
    {
      id: "2",
      text: "Notification text",
      timestamp: "10s ago",
      read: false,
    },
    {
      id: "3",
      text: "Notification text",
      timestamp: "5m ago",
      read: false,
    },
    {
      id: "4",
      text: "Notification text",
      timestamp: "8m ago",
      read: false,
    },
    {
      id: "5",
      text: "Notification text",
      timestamp: "1d ago",
      read: true,
      system: true,
    },
  ],
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen }),
  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
    })),
  markAsRead: (id) =>
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === id ? { ...n, read: true } : n
      ),
    })),
}));
